<template>
  <div class="tag-group-container">
    <div :class="{ 'tag-group-box': isOpen }" v-loading="loading"
    :style="isOpen ? {} : { height: '38px', overflow: 'hidden' }">
      <template v-for="(option, index) in filterData">
        <div class="tag-group-warp" :key="index" v-if="option">
          <div class="tag-group">
            <div class="tag-group-name tag-text">{{ option.name }}:</div>
            <div class="tag-group-items">
              <template >
                <div
                  v-for="(item, i) in option.items"
                  :key="i"
                  :class="['tag-text', 'tag-group-item', {
                    'active': activeCompare(selectedTag, item, i)
                  }]"
                  @click="changeTag(item)"
                >
                  {{ item.name }}
                  <span v-if="!emptyExceptZero(item.count)"> ({{ item.count }})</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="result-select-warp" v-if="!loading">
      <img
        :class="{ down: !isOpen }"
        src="@/assets/img/arrow.png"
        @click="collapse"
        alt
      />
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { emptyExceptZero } from '@/utils/index'

const activeCompare = (selected, item, index) => {
  const selectedGroupStr = String(selected.groupType)
  const selectedItemStr = String(selected.itemType)
  const itemGroupStr = String(item.groupType)
  const itemItemStr = String(item.itemType)
  if (index === 0) {
    return selectedGroupStr !== itemGroupStr || (selectedGroupStr === itemGroupStr && (selectedItemStr === 'null' || selectedItemStr === ''))
  }
  const notEmpty = selectedGroupStr === itemGroupStr && selectedItemStr === itemItemStr
  return notEmpty
}

defineProps({
  filterData: {
    type: Object,
    default: () => ({}),
  },
  selectedTag: {
    type: Object,
    default: () => ({
      groupType: null,
      itemType: null,
    }),
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['tagChange'])

const isOpen = ref(true)

// 合起/展开
const collapse = () => {
  isOpen.value = !isOpen.value
}

// 切换标签
const changeTag = (tag) => {
  const { groupType = null, itemType = null } = tag || {}
  emit('tagChange', {
    groupType,
    itemType,
  })
}
</script>
<style scoped lang="scss">
.tag-group-container {
  min-height: 16px;
  position: relative;
  margin-top: 16px;
  border: 1px solid #dcdee0;
  border-radius: 2px;
  .tag-group-box {
    flex: 1;
  }
  .tag-group-name {
    padding: 2px 0;
    margin-top: 2px;
  }
  .tag-group {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 4px 16px;
    align-items: flex-start;
    background: #fff;
    box-sizing: border-box;
    .tag-group-items {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .tag-group-item {
        cursor: pointer;
        margin: 2px 0 2px 12px;
        padding: 2px 8px;
        color: #333;
        &.active {
          color: #2e7eff;
          background-color: #edf4ff;
        }
      }
    }
  }
  .result-select-warp {
    position: absolute;
    width: 100%;
    bottom: -8px;
    text-align: center;
    padding: 0 16px;
    img {
      cursor: pointer;
      box-sizing: border-box;
      width: 20px;
      margin-top: -6px;
      background: #fff;
      padding: 0 4px;
    }
    .down {
      transform: rotate(180deg);
      margin-top: 0;
    }
  }
}
</style>
